import moment from 'moment';
import { t } from 'services/localization';

export const createQuoteUniqueId = (requestId: string, lineItemId: string) => `${requestId}_${lineItemId}`;

export const extractLineItemIdFromQuoteUniqueId = (uniqueId: string) => uniqueId.split('_').pop() || '';

export const getDateText = (date: string | undefined) => {
    if (moment(date).isSame(moment(), 'day')) {
        return t('today');
    }

    return moment(date).format('ll');
};
